<template>
    <div>
        <el-form :model="form" :rules="rules" ref="form" label-width="120px" style="width: 600px;">
            <el-form-item label="设备类型" prop="deviceType">
                <DeviceType v-model="deviceType" />
            </el-form-item>
            <el-form-item label="版本号" prop="versionNumber">
                <el-input v-model="form.versionNumber" placeholder="请输入版本号"></el-input>
            </el-form-item>
            <el-form-item label="加密密钥" prop="secretKey">
                <el-input v-model="form.secretKey" placeholder="请输入加密密钥"></el-input>
            </el-form-item>
            <el-form-item label="上传文件" prop="filePath">
                <uploader-file v-model="form.filePath" accept=".bin,.enc"></uploader-file>
            </el-form-item>
            <el-form-item>
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="primary" @click="handleSubmit">确认</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import UploaderFile from "@/components/UploaderFile.vue";
import { add, edit, detail } from "@/api/firmware/index";
import DeviceType from "@/components/DeviceType.vue";
export default {
    components: { UploaderFile, DeviceType },
    data() {
        return {
            form: {
                deviceType: '',
                productType: '',
                versionNumber: '',
                secretKey: '',
                filePath: ''
            },
            deviceType: [],
            rules: {
                deviceType: [{ required: true, message: '请选择设备类型', trigger: 'blur' }],
                versionNumber: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
                secretKey: [{ required: true, message: '请输入加密密钥', trigger: 'blur' }],
                filePath: [{ required: true, message: '请上传文件', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        if (this.$route.query.id) {
            this.getDetail(this.$route.query.id);
        }
    },
    watch: {
        deviceType(val) {
            if (val.length) {
                this.form.productType = val[0];
                this.form.deviceType = val[1];
            } else {
                this.form.productType = '';
                this.form.deviceType = '';
            }
        }
    },
    methods: {
        getDetail(id) {
            detail({ id }).then(({ code, result, message }) => {
                if (code == 200) {
                    this.form = result;
                    this.deviceType = [result.productType, result.deviceType];
                } else {
                    this.$message.error(message);
                }
            });
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                if (this.form.id) {
                    edit(this.form).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success('保存成功');
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    });
                } else {
                    add(this.form).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success('保存成功');
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    });
                }
            });
        },
        handleCancel() {
            this.$router.back();
        }
    }
}
</script>

<style></style>
